import { useSyncExternalStore } from 'react';
import AppDataManager from '../calling-cross-tab-utils/AppDataManager';
import WorkerConnection from '../WorkerConnection';
import CrossTabConfig from '../calling-cross-tab-utils/CrossTabConfig';
import { createUpdateProviderDetailsMessage } from 'calling-cross-tab-library/messages/ToWorkerMessages';
import { ConnectionStatusTypes } from 'shared-worker-versioning/lib/types/ConnectionStatuses';
const canSendMessage = connectionStatus => [ConnectionStatusTypes.FAILED, ConnectionStatusTypes.UNSUPPORTED].includes(connectionStatus) === false;
export const useProviderDetails = () => {
  const appData = useSyncExternalStore(AppDataManager.subscribeToAppData, AppDataManager.getAppData);
  const providerDetails = appData.providerDetails;
  return {
    providerDetails
  };
};
export const updateProviderDetails = message => {
  const providerDetailsMessage = createUpdateProviderDetailsMessage({
    providerDetails: message,
    originConnectionId: CrossTabConfig.get().connectionId
  });
  const connectionStatus = AppDataManager.getConnectionStatus();
  if (canSendMessage(connectionStatus)) {
    WorkerConnection.sendMessage(providerDetailsMessage);
    return Promise.resolve();
  }
  return Promise.reject(new Error(`Unable to send message with status ${connectionStatus}`));
};